export default function permission({next, store, to}) {
    const permissionName = to.meta.permission;
    const permissions = store.state.auth.permissions;
    const havePermission = permissions.indexOf(permissionName);

    if (havePermission === -1) {
        return next({name: '403'});
    }
    //Check if the platform is in maintenance mode for external users
    if(store.state.auth.currentUser.role){
        if(!['b2b_super_admin'].includes(store.state.auth.currentUser.role.name)){
            //return next({name: 'maintenance'});
        }
    }

    return next()
}